/* eslint-disable max-len */
import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_COMMENTS = gql`
query getComments($deleted: Boolean, $censored: Boolean, $searchPostSlugName: String, $searchCommentText: String, $searchNickname: String, $startDate: String, $finishDate: String, $from: Int, $to: Int, $sortingField: String, $sortingType: Int) {
  getComments(deleted: $deleted, censored: $censored, searchPostSlugName: $searchPostSlugName, searchCommentText: $searchCommentText, searchNickname: $searchNickname, startDate: $startDate, finishDate: $finishDate, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType) {
    isAuth
    total
    query
    comments {
      commentId
      postSlugName
      userId
      email
      nickname
      commentText
      createdAt
      hasBadge
      deleted
      censored
    }
  }
}
`;

const getComments = async (variables) => {
  try {
    const result = await client.query({
      query: GET_COMMENTS,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getComments: commentsData } } = result;

    if (commentsData) {
      return commentsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getComments = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getComments Error: ${error}`);
    return null;
  }
};

export default getComments;
